import { isPhone } from 'shared/envUtils';

export const isMobileFullScreen = (fullScreen: boolean): boolean =>
  isPhone() && fullScreen;
